export const STAGES = [
  "Identified",
  "Appraising",
  "Offer Ready",
  "In Negotiation",
  "Follow Up",
  "Legal / Due Diligence",
  "Completed",
]

export const ACTION_FOR_STAGE = {
  Identified: "Analyse Deal",
  Appraising: "Complete Appraisal",
  "Offer Ready": "Start Negotiation Discovery",
  "In Negotiation": "Log Update",
  "Follow Up": "Follow Up Vendor",
  "Legal / Due Diligence": "Chase Legal",
  Completed: "View Details",
}

export const STATUS_FOR_STAGE = {
  Identified: "New",
  Appraising: "Action Required",
  "Offer Ready": "Action Required",
  "In Negotiation": "Active",
  "Follow Up": "Inactive",
  "Legal / Due Diligence": "Active",
  Completed: "Inactive",
}

export const DETAIL_UNLOCK_FOR_STAGE = {
  Identified: 1,
  Appraising: 4,
  "Offer Ready": 5,
  "In Negotiation": 5,
  "Follow Up": 5,
  "Legal / Due Diligence": 5,
  Completed: 5,
}

export const PRIORITY_DEALS = [
  {
    address: "12 Chester Road",
    stage: "Appraising",
    status: "New",
    action: "Analyse Deal",
    score: 88,
    image: "https://images.unsplash.com/photo-1764824079325-f040ea98e09e?auto=format&fit=crop&w=240&q=60",
  },
  {
    address: "45 High Street",
    stage: "In Negotiation",
    status: "6 days inactive",
    action: "Follow Up Vendor",
    score: 92,
    image: "https://images.unsplash.com/photo-1710883734889-5a0b8ab6bfcf?auto=format&fit=crop&w=240&q=60",
  },
  {
    address: "88 Church Lane",
    stage: "Offer Ready",
    status: "Action Required",
    action: "Start Negotiation Discovery",
    score: 95,
    image: "https://images.unsplash.com/photo-1764416166529-99edb0e405a6?auto=format&fit=crop&w=240&q=60",
  },
]
